/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */
@file:UseContextualSerialization(LocalDate::class)

package pl.finn.forms.model

import io.kvision.types.LocalDate
import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization

@Serializable
data class FormStructureModel(
  val elementsList: DocumentTreeNode?,
  val attachments: List<Attachment>,
  val apiRequest: Map<String, String?>?,
  val url: String,
  val token: String?
)

@Serializable
data class Attachment(
  val name: String,
  val description: String? = null,
  val mime: String? = null,
  val content: String? = null,
  val parentName: String? = null,
)